export default __webpack_public_path__ + "static/media/JAVA.bb0c6b8a.png";